// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Tx8E","row":"styles_row__2cf7a"};